import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReportWizard } from '../../components/ReportWizard';
export function ReportPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const category = location.state?.category || 'general';
  const handleBack = () => {
    navigate('/guest');
  };
  const handleSubmit = (data: any) => {
    console.log('Form submitted:', {
      category,
      ...data
    });
    // Simulate API call
    setTimeout(() => {
      navigate('/guest/confirmation');
    }, 500);
  };
  return <ReportWizard category={category} onBack={handleBack} onSubmit={handleSubmit} data-id="element-911" />;
}